/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import { MdKeyboardArrowRight } from "react-icons/md";
import { BiHomeAlt } from "react-icons/bi";
import "../../AdminScreens/ADMLeavesRequest/ADMLeavesRequest.css";
import Select from "react-select";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import {
  Apiurl,
  GetToken,
  RemoveUserSession,
  calculateWorkingDays,
  getDurationEnumValue,
  getTimeLevelLeaveRestrictions,
} from "../../../Utils/utils";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "../../../Components/loader/loader";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";

const ADMLeavesRequest = () => {
  const [loading, setLoading] = useState(false);

  const LoginToken = GetToken();
  const [profileData, setProfileData] = useState([]);

  const navigate = useNavigate();
  const [minLeaveToDate, setMinLeaveToDate] = useState(null);
  const [errorLeaveType, setErrorLeaveType] = useState(false);
  const [errorLeaveFrom, setErrorLeaveFrom] = useState(false);
  const [errorLeaveTo, setErrorLeaveTo] = useState(false);
  const [errorNoOfDays, setErrorNoOfDays] = useState(false);
  const [errorReason, setErrorReason] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true);
  const [selectedLeaveType, setSelectedLeaveType] = useState(null);
  const [data, setdata] = useState("");
  const [MedicalDocumentsfiles, setMedicalDocumentsFiles] = useState([]);
  const fileInputRef = useRef(null);

  const [leaveFromType, setLeaveFromType] = useState("Full Day");
  const [leaveToType, setLeaveToType] = useState("Full Day");
  const [leaveFromSlot, setLeaveFromSlot] = useState(null);
  const [leaveToSlot, setLeaveToSlot] = useState(null);
  const [fromDateRestrictions, setFromDateRestrictions] = useState(null);
  const [toDateRestrictions, setToDateRestrictions] = useState(null);
  const [applyLeaves, setApplyLeaves] = useState({
    Name: "",
    LeaveType: "",
    LeaveFrom: "",
    LeaveTo: "",
    NoOfDays: "",
    Reason: "",
  });
  const [allLeavesList, setallLeavesList] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const location = useLocation();
  const leaveRequestData = location.state?.leaveRequestData;
  const [errorMedicalDoc, setErrorMedicalDoc] = useState(false);

  useEffect(() => {
    if (leaveRequestData) {
      setApplyLeaves({
        LeaveType: leaveRequestData?.LeaveTypes,
        LeaveFrom: leaveRequestData?.StartDate?.split("T")[0],
        LeaveTo: leaveRequestData?.EndDate?.split("T")[0],
        NoOfDays: leaveRequestData?.NumberofDays,
        Reason: leaveRequestData?.Reason,
      });
    }
  }, [leaveRequestData]);

  useEffect(() => {
    const fetchHolidays = () => {
      const option = {
        method: "GET",
        headers: {
          authorization: `Bearer ${LoginToken}`,
        },
        url: `${Apiurl()}/Holiday/GetAllHoliday`,
      };
      axios(option)
        .then((response) => {
          const holidayData = JSON.parse(response?.data?.data || "[]");
          const holidayDates = holidayData?.map((h) => h.HolidayDate);
          setHolidays(holidayDates || []);
        })
        .catch(() => {
          setHolidays([]);
        });
    };
    fetchHolidays();
  }, [LoginToken]);

  useEffect(() => {
    if (applyLeaves?.LeaveFrom) {
      const fromRestrictions = getTimeLevelLeaveRestrictions(
        applyLeaves?.LeaveFrom
      );
      setFromDateRestrictions(fromRestrictions);

      if (
        leaveFromSlot &&
        leaveFromType === "Half Day" &&
        !fromRestrictions.availableHalfDaySlots.includes(parseInt(leaveFromSlot))
      ) {
        setLeaveFromSlot(null);
      } else if (
        leaveFromSlot &&
        leaveFromType === "Short Day" &&
        !fromRestrictions.availableShortLeaveSlots.includes(parseInt(leaveFromSlot))
      ) {
        setLeaveFromSlot(null);
      }
    }
    if (applyLeaves?.LeaveTo) {
      const toRestrictions = getTimeLevelLeaveRestrictions(applyLeaves?.LeaveTo);
      setToDateRestrictions(toRestrictions);

      if (
        leaveToSlot &&
        leaveToType === "Half Day" &&
        !toRestrictions.availableHalfDaySlots.includes(parseInt(leaveToSlot))
      ) {
        setLeaveToSlot(null);
      } else if (
        leaveToSlot &&
        leaveToType === "Short Day" &&
        !toRestrictions.availableShortLeaveSlots.includes(parseInt(leaveToSlot))
      ) {
        setLeaveToSlot(null);
      }
    }
  }, [
    applyLeaves?.LeaveFrom,
    applyLeaves?.LeaveTo,
    leaveFromType,
    leaveToType,
    leaveFromSlot,
    leaveToSlot,
  ]);

  useEffect(() => {
    if (applyLeaves?.LeaveFrom && applyLeaves?.LeaveTo) {
      const days = calculateWorkingDays(
        applyLeaves?.LeaveFrom,
        applyLeaves?.LeaveTo,
        holidays,
        leaveFromType,
        leaveToType
      );

      setApplyLeaves({ ...applyLeaves, NoOfDays: days });
    }
  }, [
    applyLeaves?.LeaveFrom,
    applyLeaves?.LeaveTo,
    leaveFromType,
    leaveToType,
    leaveFromSlot,
    leaveToSlot,
    holidays,
  ]);

  const validate = () => {
    if (!applyLeaves?.LeaveFrom) {
      setErrorLeaveFrom("userLeaveFrom");
      return false;
    }
    if (!applyLeaves?.LeaveTo) {
      setErrorLeaveTo("userLeaveTo");
      return false;
    }
    if (!applyLeaves?.NoOfDays) {
      setErrorNoOfDays("userNoOfdays");
      return false;
    }
    if (!applyLeaves?.LeaveType) {
      setErrorLeaveType("userLeaveType");
      return false;
    }
    if (!applyLeaves?.Reason) {
      setErrorReason("userReason");
      return false;
    }
    if (
      applyLeaves?.LeaveType?.Name === "Sick Leave" &&
      (!MedicalDocumentsfiles || MedicalDocumentsfiles.length === 0)
    ) {
      setErrorMedicalDoc("userMedicalDoc");
      toast.error("Medical document is mandatory for Sick Leave");
      return false;
    }
    return true;
  };

  const [previousDate, setPreviousDate] = useState(null);

  const handleLeaveSubmit = () => {
    if (!validate()) return;
    setLoading(true);
    const LoginToken = GetToken();
    const formData = new FormData();
    if (leaveRequestData) {
      formData.append("Id", leaveRequestData?.Id);
    }
    formData.append("StartDate", applyLeaves.LeaveFrom);
    formData.append("EndDate", applyLeaves.LeaveTo);
    formData.append("Reason", applyLeaves.Reason);
    formData.append("NumberofDays", parseFloat(applyLeaves?.NoOfDays).toString());
    formData.append("LeaveType", applyLeaves?.LeaveType?.Id);
    formData.append("LeaveFromDuration", getDurationEnumValue(leaveFromType));
    formData.append("LeaveToDuration", getDurationEnumValue(leaveToType));

    if (leaveFromSlot) {
      formData.append("LeaveFromSlot", leaveFromSlot);
    }
    if (leaveToSlot) {
      formData.append("LeaveToSlot", leaveToSlot);
    }
    if (
      applyLeaves.LeaveType.Name === "Sick Leave" &&
      MedicalDocumentsfiles &&
      MedicalDocumentsfiles.length > 0
    ) {
      MedicalDocumentsfiles.forEach((file) => {
        formData.append("MedicalDocuments", file);
      });
    }
    setPreviousDate(applyLeaves.LeaveFrom || applyLeaves.LeaveTo);

    const option = {
      method: "POST",
      headers: {
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Leave/ApplyLeave`,
      data: formData,
    };

    axios(option)
      .then((e) => {
        if (previousDate === data.StartDate && data.EndDate) {
          toast.error("0111100000 date ");
          return false;
        } else if (e?.status === 200) {
          toast.success(e?.data?.message);
          setApplyLeaves({
            LeaveType: "",
            LeaveFrom: "",
            LeaveTo: "",
            NoOfDays: "",
            Reason: "",
          });
          setMedicalDocumentsFiles([]);
          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
          setErrorLeaveType(false);
          setErrorLeaveFrom(false);
          setErrorLeaveTo(false);
          setErrorNoOfDays(false);
          setErrorReason(false);
          setErrorMedicalDoc(false);
          navigate("/Adm/LeaveManagement/AllLeaveRequests");
        }
        setLoading(false);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
        setLoading(false);

        if (error?.response?.status === 401) {
          toast.error("Your session has expired");
          RemoveUserSession();
          navigate("/", { replace: true });
        }
      });
  };

  const [leaveTypeData, setLeaveTypeData] = useState([]);

  const RetrieveLeaveTypes = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Leave/GetLeaveTypes`,
    };
    axios(option)
      .then((response) => {
        const data = JSON.parse(response?.data?.data);
        const modifiedData = data?.map((leave) => {
          if (leave.Name === "OD") {
            return { ...leave, Name: "Outdoor Leave" };
          } else {
            return leave;
          }
        });
        setLeaveTypeData(modifiedData);
        setallLeavesList(modifiedData);
      })
      .catch(() => {});
  };

  useEffect(() => {
    RetrieveLeaveTypes();
  }, []);

  useEffect(() => {
    let filterData = allLeavesList;

    const today = moment().startOf("day");
    const selectedDate = applyLeaves?.LeaveFrom
      ? moment(applyLeaves.LeaveFrom).startOf("day")
      : null;

    if (selectedDate && selectedDate.isBefore(today)) {
      filterData = allLeavesList?.filter((item) => item?.Name === "Sick Leave");
    } else {
      if (applyLeaves?.NoOfDays > 1 && applyLeaves?.NoOfDays <= 6) {
        filterData = allLeavesList?.filter(
          (item) => item?.Name !== "Half Day" && item?.Name !== "Short Leave"
        );
      } else if (applyLeaves?.NoOfDays === 6) {
        filterData = allLeavesList?.filter(
          (item) => item?.Name === "Casual Leave" || item?.Name === "Sick Leave"
        );
      } else if (applyLeaves?.NoOfDays > 6) {
        filterData = allLeavesList?.filter(
          (item) => item?.Name === "Casual Leave" || item?.Name === "OD"
        );
      }
    }

    setLeaveTypeData(filterData);
  }, [applyLeaves?.LeaveFrom, applyLeaves?.NoOfDays, allLeavesList]);

  const handleLeaveTypeChange = (selectedOption) => {
    if (
      applyLeaves?.NoOfDays > 2 &&
      (selectedOption?.Name === "Short Leave" ||
        selectedOption?.Name === "Half Day")
    ) {
      toast.warning(
        "Sick Leave and Half Day are not allowed for more than 2 days."
      );
      return;
    }
    if (applyLeaves?.NoOfDays > 6 && selectedOption?.Name === "Sick Leave") {
      toast.warning("Sick Leave is not allowed for more than 6 days.");
      return;
    }
    setSelectedLeaveType(selectedOption);
    setApplyLeaves({ ...applyLeaves, LeaveType: selectedOption });
    setErrorMedicalDoc(false);

    if (selectedOption?.Name !== "Sick Leave") {
      setMedicalDocumentsFiles([]);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }

    const today = new Date();
    const fifteenDaysAgo = new Date(today);
    fifteenDaysAgo.setDate(today.getDate() - 30);
    const last15DaysDateString = fifteenDaysAgo.toISOString().split("T")[0];

    if (selectedOption?.Name === "Sick Leave") {
      setMinLeaveToDate(last15DaysDateString);
    } else {
      setMinLeaveToDate(null);
    }
  };

  const handleCancelFields = () => {
    setApplyLeaves({
      LeaveType: "",
      LeaveFrom: "",
      LeaveTo: "",
      NoOfDays: "",
      Reason: "",
    });
    setMedicalDocumentsFiles([]);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    setErrorLeaveType(false);
    setErrorLeaveFrom(false);
    setErrorLeaveTo(false);
    setErrorNoOfDays(false);
    setErrorReason(false);
    setErrorMedicalDoc(false);
  };

  useEffect(() => {
    setLoading(true);
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    setLoading(true);
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 2000);
    GetProfile();
    return () => clearTimeout(timeout);
  }, []);

  const GetProfile = () => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Profile/GetProfile`,
    };
    axios(option)
      .then((response) => {
        const data = JSON.parse(response?.data?.data);
        setProfileData(data);
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          toast.error("Your session has expired");
          RemoveUserSession();
          navigate("/", { replace: true });
        }
      });
  };

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);

  const handleImageChange = (e) => {
    const files = e.target.files;

    if (!files || files.length === 0) {
      setMedicalDocumentsFiles([]);
      return;
    }

    const fileArray = Array.from(files);
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "image/jpg",
      "application/pdf",
    ];
    const maxFileSize = 5 * 1024 * 1024;

    const invalidType = fileArray.find(
      (file) => !allowedTypes.includes(file.type)
    );
    if (invalidType) {
      toast.error("Only JPEG, PNG, JPG, or PDF files are allowed");
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      setMedicalDocumentsFiles([]);
      return;
    }

    const invalidSize = fileArray.find((file) => file.size > maxFileSize);
    if (invalidSize) {
      toast.error("Each file size must not exceed 5MB");
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      setMedicalDocumentsFiles([]);
      return;
    }

    setMedicalDocumentsFiles(fileArray);
    setErrorMedicalDoc(false);
    toast.success("Medical document uploaded successfully");
  };

  const currentDate = new Date();
  let minDate = new Date(currentDate.getTime());
  minDate.setDate(currentDate.getDate() - 30);
  minDate = minDate.toISOString().split("T")[0];

  return (
    <>
      {loading ? <Loader /> : null}
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />

        <section
          className={
            showSidebar
              ? "ADM-addEmloyees-section"
              : "ADM-addEmloyees-section-new"
          }
        >
          <div className="ADM-addEmloyees-all-icons">
            <div>
              <p className="ADM-MAIN-HEADING">
                {leaveRequestData ? "Edit Leaves" : "Apply Leaves"}
              </p>
            </div>
            <div className="dashboiard-inner-header">
              <BiHomeAlt className="ADM-home-icon-header-inn" />
              <MdKeyboardArrowRight />
              <p> Leaves Management </p>
              <MdKeyboardArrowRight />
              <p>{leaveRequestData ? "Edit Leaves" : "Apply Leaves"}</p>
            </div>
          </div>

          <div className="ADM-Addadmin-main-container">
            <div className="ADM-Addadmin-outter-container">
              <div className="ADM-Addadmin-inner-container">
                <div className="ADM-Addadmin-heading">
                  <p>{leaveRequestData ? "Edit Leaves" : "Apply Leaves"}</p>
                </div>

                <div className="ADM-Addadmin-inner-box row adm-leave-form-row">
                  <div
                    className="adm-flex-row"
                    style={{ display: "flex", gap: "15px", marginBottom: "20px" }}
                  >
                    <div className="Addadmin-inputs" style={{ flex: 1 }}>
                      <label>Leave From</label>
                      <input
                        value={applyLeaves.LeaveFrom}
                        type="date"
                        onChange={(e) => {
                          const selectedDate = e?.target?.value;
                          setApplyLeaves({
                            ...applyLeaves,
                            LeaveFrom: selectedDate,
                            LeaveTo: "",
                            NoOfDays: "",
                          });
                          setMinLeaveToDate(selectedDate);
                          setErrorLeaveType();
                        }}
                        min={minDate}
                      />
                      {errorLeaveFrom === "userLeaveFrom" && !applyLeaves?.LeaveFrom ? (
                        <span className="contact_error-dob">
                          Leave From is required.
                        </span>
                      ) : null}
                    </div>

                    {applyLeaves.LeaveFrom !== applyLeaves.LeaveTo && (
                      <>
                        <div className="Addadmin-inputs" style={{ flex: 1 }}>
                          <label>Leave Duration</label>
                          <select
                            value={leaveFromType}
                            onChange={(e) => {
                              setLeaveFromType(e.target.value);
                              setLeaveFromSlot(null);
                            }}
                            className="leave-select-input"
                          >
                            <option
                              value="Full Day"
                              disabled={
                                fromDateRestrictions &&
                                !fromDateRestrictions.canApplyFullDay
                              }
                            >
                              Full Day
                            </option>
                            <option
                              value="Half Day"
                              disabled={
                                fromDateRestrictions &&
                                !fromDateRestrictions.canApplyHalfDay
                              }
                            >
                              Half Day
                            </option>
                            <option
                              value="Short Day"
                              disabled={
                                fromDateRestrictions &&
                                !fromDateRestrictions.canApplyShortLeave
                              }
                            >
                              Short Day
                            </option>
                          </select>
                          {fromDateRestrictions?.restrictionMessage && (
                            <small className="adm-leave-restriction-note">
                              {fromDateRestrictions.restrictionMessage}
                            </small>
                          )}
                        </div>

                        {(leaveFromType === "Half Day" ||
                          leaveFromType === "Short Day") && (
                          <div className="Addadmin-inputs" style={{ flex: 1 }}>
                            <label>Leave Slot</label>
                            <select
                              value={leaveFromSlot || ""}
                              onChange={(e) => setLeaveFromSlot(e.target.value)}
                              className="leave-select-input"
                            >
                              <option value="">Select Slot</option>
                              {leaveFromType === "Half Day" ? (
                                <>
                                  <option
                                    value="1"
                                    disabled={
                                      fromDateRestrictions &&
                                      !fromDateRestrictions.availableHalfDaySlots.includes(1)
                                    }
                                  >
                                    9:30 AM - 1:30 PM
                                  </option>
                                  <option
                                    value="2"
                                    disabled={
                                      fromDateRestrictions &&
                                      !fromDateRestrictions.availableHalfDaySlots.includes(2)
                                    }
                                  >
                                    2:00 PM - 6:00 PM
                                  </option>
                                </>
                              ) : (
                                <>
                                  <option
                                    value="1"
                                    disabled={
                                      fromDateRestrictions &&
                                      !fromDateRestrictions.availableShortLeaveSlots.includes(1)
                                    }
                                  >
                                    9:30 AM - 11:30 AM
                                  </option>
                                  <option
                                    value="2"
                                    disabled={
                                      fromDateRestrictions &&
                                      !fromDateRestrictions.availableShortLeaveSlots.includes(2)
                                    }
                                  >
                                    11:30 AM - 1:30 PM
                                  </option>
                                  <option
                                    value="3"
                                    disabled={
                                      fromDateRestrictions &&
                                      !fromDateRestrictions.availableShortLeaveSlots.includes(3)
                                    }
                                  >
                                    2:00 PM - 4:00 PM
                                  </option>
                                  <option
                                    value="4"
                                    disabled={
                                      fromDateRestrictions &&
                                      !fromDateRestrictions.availableShortLeaveSlots.includes(4)
                                    }
                                  >
                                    4:00 PM - 6:00 PM
                                  </option>
                                </>
                              )}
                            </select>
                          </div>
                        )}
                      </>
                    )}
                  </div>

                  {applyLeaves.LeaveFrom === applyLeaves.LeaveTo &&
                    applyLeaves.LeaveFrom && (
                      <div
                        className="adm-flex-row"
                        style={{ display: "flex", gap: "15px", marginBottom: "20px" }}
                      >
                        <div className="Addadmin-inputs" style={{ flex: 1 }}>
                          <label>Leave Duration</label>
                          <select
                            value={leaveFromType}
                            onChange={(e) => {
                              setLeaveFromType(e.target.value);
                              setLeaveFromSlot(null);
                            }}
                            className="leave-select-input"
                          >
                            <option
                              value="Full Day"
                              disabled={
                                fromDateRestrictions &&
                                !fromDateRestrictions.canApplyFullDay
                              }
                            >
                              Full Day
                            </option>
                            <option
                              value="Half Day"
                              disabled={
                                fromDateRestrictions &&
                                !fromDateRestrictions.canApplyHalfDay
                              }
                            >
                              Half Day
                            </option>
                            <option
                              value="Short Day"
                              disabled={
                                fromDateRestrictions &&
                                !fromDateRestrictions.canApplyShortLeave
                              }
                            >
                              Short Day
                            </option>
                          </select>
                          {fromDateRestrictions?.restrictionMessage && (
                            <small className="adm-leave-restriction-note">
                              {fromDateRestrictions.restrictionMessage}
                            </small>
                          )}
                        </div>

                        {(leaveFromType === "Half Day" ||
                          leaveFromType === "Short Day") && (
                          <div className="Addadmin-inputs" style={{ flex: 1 }}>
                            <label>Leave Slot</label>
                            <select
                              value={leaveFromSlot || ""}
                              onChange={(e) => setLeaveFromSlot(e.target.value)}
                              className="leave-select-input"
                            >
                              <option value="">Select Slot</option>
                              {leaveFromType === "Half Day" ? (
                                <>
                                  <option
                                    value="1"
                                    disabled={
                                      fromDateRestrictions &&
                                      !fromDateRestrictions.availableHalfDaySlots.includes(1)
                                    }
                                  >
                                    9:30 AM - 1:30 PM
                                  </option>
                                  <option
                                    value="2"
                                    disabled={
                                      fromDateRestrictions &&
                                      !fromDateRestrictions.availableHalfDaySlots.includes(2)
                                    }
                                  >
                                    2:00 PM - 6:00 PM
                                  </option>
                                </>
                              ) : (
                                <>
                                  <option
                                    value="1"
                                    disabled={
                                      fromDateRestrictions &&
                                      !fromDateRestrictions.availableShortLeaveSlots.includes(1)
                                    }
                                  >
                                    9:30 AM - 11:30 AM
                                  </option>
                                  <option
                                    value="2"
                                    disabled={
                                      fromDateRestrictions &&
                                      !fromDateRestrictions.availableShortLeaveSlots.includes(2)
                                    }
                                  >
                                    11:30 AM - 1:30 PM
                                  </option>
                                  <option
                                    value="3"
                                    disabled={
                                      fromDateRestrictions &&
                                      !fromDateRestrictions.availableShortLeaveSlots.includes(3)
                                    }
                                  >
                                    2:00 PM - 4:00 PM
                                  </option>
                                  <option
                                    value="4"
                                    disabled={
                                      fromDateRestrictions &&
                                      !fromDateRestrictions.availableShortLeaveSlots.includes(4)
                                    }
                                  >
                                    4:00 PM - 6:00 PM
                                  </option>
                                </>
                              )}
                            </select>
                          </div>
                        )}
                      </div>
                    )}

                  <div
                    className="adm-flex-row"
                    style={{ display: "flex", gap: "15px", marginBottom: "20px" }}
                  >
                    <div className="Addadmin-inputs" style={{ flex: 1 }}>
                      <label>Leave To</label>
                      <input
                        type="date"
                        value={applyLeaves?.LeaveTo}
                        onChange={(e) => {
                          setApplyLeaves({
                            ...applyLeaves,
                            LeaveTo: e?.target?.value,
                            LeaveType: "",
                          });
                          setErrorLeaveType();
                        }}
                        min={minLeaveToDate || minDate}
                      />
                      {errorLeaveTo === "userLeaveTo" && !applyLeaves?.LeaveTo ? (
                        <span className="contact_error-dob">
                          Leave To is required.
                        </span>
                      ) : null}
                    </div>

                    {applyLeaves.LeaveFrom !== applyLeaves.LeaveTo && (
                      <>
                        <div className="Addadmin-inputs" style={{ flex: 1 }}>
                          <label>Leave Duration</label>
                          <select
                            value={leaveToType}
                            onChange={(e) => {
                              setLeaveToType(e.target.value);
                              setLeaveToSlot(null);
                            }}
                            className="leave-select-input"
                          >
                            <option
                              value="Full Day"
                              disabled={
                                toDateRestrictions &&
                                !toDateRestrictions.canApplyFullDay
                              }
                            >
                              Full Day
                            </option>
                            <option
                              value="Half Day"
                              disabled={
                                toDateRestrictions &&
                                !toDateRestrictions.canApplyHalfDay
                              }
                            >
                              Half Day
                            </option>
                            <option
                              value="Short Day"
                              disabled={
                                toDateRestrictions &&
                                !toDateRestrictions.canApplyShortLeave
                              }
                            >
                              Short Day
                            </option>
                          </select>
                          {toDateRestrictions?.restrictionMessage && (
                            <small className="adm-leave-restriction-note">
                              {toDateRestrictions.restrictionMessage}
                            </small>
                          )}
                        </div>

                        {(leaveToType === "Half Day" ||
                          leaveToType === "Short Day") && (
                          <div className="Addadmin-inputs" style={{ flex: 1 }}>
                            <label>Leave Slot</label>
                            <select
                              value={leaveToSlot || ""}
                              onChange={(e) => setLeaveToSlot(e.target.value)}
                              className="leave-select-input"
                            >
                              <option value="">Select Slot</option>
                              {leaveToType === "Half Day" ? (
                                <>
                                  <option
                                    value="1"
                                    disabled={
                                      toDateRestrictions &&
                                      !toDateRestrictions.availableHalfDaySlots.includes(1)
                                    }
                                  >
                                    9:30 AM - 1:30 PM
                                  </option>
                                  <option
                                    value="2"
                                    disabled={
                                      toDateRestrictions &&
                                      !toDateRestrictions.availableHalfDaySlots.includes(2)
                                    }
                                  >
                                    2:00 PM - 6:00 PM
                                  </option>
                                </>
                              ) : (
                                <>
                                  <option
                                    value="1"
                                    disabled={
                                      toDateRestrictions &&
                                      !toDateRestrictions.availableShortLeaveSlots.includes(1)
                                    }
                                  >
                                    9:30 AM - 11:30 AM
                                  </option>
                                  <option
                                    value="2"
                                    disabled={
                                      toDateRestrictions &&
                                      !toDateRestrictions.availableShortLeaveSlots.includes(2)
                                    }
                                  >
                                    11:30 AM - 1:30 PM
                                  </option>
                                  <option
                                    value="3"
                                    disabled={
                                      toDateRestrictions &&
                                      !toDateRestrictions.availableShortLeaveSlots.includes(3)
                                    }
                                  >
                                    2:00 PM - 4:00 PM
                                  </option>
                                  <option
                                    value="4"
                                    disabled={
                                      toDateRestrictions &&
                                      !toDateRestrictions.availableShortLeaveSlots.includes(4)
                                    }
                                  >
                                    4:00 PM - 6:00 PM
                                  </option>
                                </>
                              )}
                            </select>
                          </div>
                        )}
                      </>
                    )}
                  </div>

                  <div className="Addadmin-inputs col-md12 adm-full-width-field">
                    <label>Number of Days</label>
                    <input
                      className="no-of-days-cursor"
                      type="number"
                      value={applyLeaves?.NoOfDays}
                      onChange={(e) =>
                        setApplyLeaves({
                          ...applyLeaves,
                          NoOfDays: e?.target?.value,
                        })
                      }
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorNoOfDays("userNoOfdays");
                        } else {
                          setErrorNoOfDays("false");
                        }
                      }}
                      disabled
                    />
                    {errorNoOfDays === "userNoOfdays" && !applyLeaves?.NoOfDays ? (
                      <span className="contact_error-dob">
                        Number of Days is required.
                      </span>
                    ) : null}
                  </div>

                  <div className="Addadmin-inputs col-md12 adm-full-width-field">
                    <div className="addemp-react-select-input">
                      <label>Leave Type</label>
                      <Select
                        classNamePrefix="ADM-leave-request-input"
                        placeholder="Select Leave Type"
                        value={applyLeaves?.LeaveType}
                        onChange={handleLeaveTypeChange}
                        options={leaveTypeData}
                        getOptionLabel={(options) => options?.Name}
                        getOptionValue={(options) => options?.Id}
                        onBlur={(e) => {
                          if (!e?.target?.value) {
                            setErrorLeaveType("userLeaveType");
                          } else {
                            setErrorLeaveType("false");
                          }
                        }}
                      />
                      {errorLeaveType === "userLeaveType" && !applyLeaves?.LeaveType ? (
                        <span className="contact_error-Addadmin">
                          Leave Type is required.
                        </span>
                      ) : null}
                    </div>

                    {applyLeaves?.LeaveType?.Name === "Sick Leave" && (
                      <div className="File-uploder adm-medical-upload-block">
                        <label>
                          Please upload Medical Bills of the Hospital (Multiple Files)*
                        </label>

                        <div className="adm-medical-upload-box">
                          <input
                            type="file"
                            id="admMedicalDocuments"
                            ref={fileInputRef}
                            onChange={handleImageChange}
                            accept=".jpeg,.jpg,.png,.pdf"
                            multiple
                            className="adm-medical-file-input"
                          />
                          <label
                            htmlFor="admMedicalDocuments"
                            className="adm-medical-file-input-label"
                          >
                            Choose Files
                          </label>
                          <span className="adm-medical-file-input-text">
                            {MedicalDocumentsfiles.length > 0
                              ? `${MedicalDocumentsfiles.length} file(s) selected`
                              : "No file chosen"}
                          </span>
                        </div>

                        {MedicalDocumentsfiles.length > 0 && (
                          <div className="adm-medical-file-list">
                            {MedicalDocumentsfiles.map((file, index) => (
                              <div className="adm-medical-file-item" key={index}>
                                {file.name}
                              </div>
                            ))}
                          </div>
                        )}

                        {errorMedicalDoc === "userMedicalDoc" &&
                        (!MedicalDocumentsfiles ||
                          MedicalDocumentsfiles.length === 0) ? (
                          <span className="contact_error-dob">
                            Medical document is required for Sick Leave
                          </span>
                        ) : null}
                      </div>
                    )}
                  </div>

                  <div className="Addadmin-inputs col-md12 adm-full-width-field adm-reason-field">
                    <label>Reason</label>
                    <textarea
                      className="reason-input"
                      cols="30"
                      rows="8"
                      value={applyLeaves?.Reason}
                      onChange={(e) =>
                        setApplyLeaves({
                          ...applyLeaves,
                          Reason: e?.target?.value,
                        })
                      }
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorReason("userReason");
                        } else {
                          setErrorReason("false");
                        }
                      }}
                    />
                    {errorReason === "userReason" && !applyLeaves?.Reason ? (
                      <span className="contact_error-dob">
                        Reason is required.
                      </span>
                    ) : null}
                  </div>

                  <div className="Addadmin-buttons buttons-for-leave-apply">
                    <button
                      className="Addadmin-submit-button-apply-leave"
                      style={{
                        backgroundColor:
                          applyLeaves?.LeaveType &&
                          applyLeaves?.LeaveFrom &&
                          applyLeaves?.LeaveTo &&
                          applyLeaves?.NoOfDays &&
                          applyLeaves?.Reason
                            ? "#3f51b5"
                            : "rgba(0, 0, 0, .12)",
                        color:
                          applyLeaves?.LeaveType &&
                          applyLeaves?.LeaveFrom &&
                          applyLeaves?.LeaveTo &&
                          applyLeaves?.NoOfDays &&
                          applyLeaves?.Reason
                            ? "#fff"
                            : "rgba(0, 0, 0, .38)",
                      }}
                      onClick={() => handleLeaveSubmit()}
                    >
                      {leaveRequestData ? "Update" : "Submit"}
                    </button>

                    <button
                      className="Addadmin-Cancel-button-apply-leave"
                      style={{
                        backgroundColor:
                          !applyLeaves.LeaveType &&
                          !applyLeaves.LeaveFrom &&
                          !applyLeaves.LeaveTo &&
                          !applyLeaves.Reason
                            ? "rgba(0, 0, 0, 0.12)"
                            : "#F44336",
                        color:
                          !applyLeaves.LeaveType &&
                          !applyLeaves.LeaveFrom &&
                          !applyLeaves.NoOfDays &&
                          !applyLeaves.Reason
                            ? "rgba(0, 0, 0, 0.38)"
                            : "#ffffff",
                      }}
                      onClick={() => handleCancelFields()}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ADMLeavesRequest;